import React from 'react'
import queryString from 'query-string'

import { RouteComponentProps, withRouter, Link } from 'react-router-dom'
import {
    Box,
    Paper,
    Link as MuiLink,
    Typography,
    Button,
    Popper,
    MenuList,
    Grow,
    ClickAwayListener,
    ClickAwayListenerProps,
    ListItem,
    ListItemButton,
    ListItemButtonProps,
    ListItemText,
    MenuListProps,
} from '@mui/material'
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material'

import { useGetPastSearchesQuery } from '../../../generated/graphql'

const RecentSearch = ({ location: { search } }: RouteComponentProps): React.ReactElement => {
    const { data } = useGetPastSearchesQuery()
    let { filter } = queryString.parse(search)
    const anchorRef = React.useRef<HTMLButtonElement>(null)
    const [open, setOpen] = React.useState(false)

    if (!filter) {
        filter = 'ALL_VEHICLES'
    }

    const pastSearches = data?.pastSearches ?? []

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClickAway: ClickAwayListenerProps['onClickAway'] = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return
        }
        setOpen(false)
    }

    const handleListItemButtonClick: ListItemButtonProps['onClick'] = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return
        }
        setOpen(false)
    }

    const handleListKeyDown: MenuListProps['onKeyDown'] = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault()
            setOpen(false)
        }
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {pastSearches.length >= 1 ? (
                <Button
                    size="small"
                    ref={anchorRef}
                    variant="outlined"
                    color="primary"
                    onClick={handleToggle}
                    endIcon={<ArrowDropDownIcon />}
                    sx={{ ml: 0.5 }}
                >
                    Recent
                </Button>
            ) : undefined}
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClickAway}>
                                <MenuList
                                    autoFocusItem={open}
                                    onKeyDown={handleListKeyDown}
                                    sx={{ display: 'flex', flexDirection: 'column' }}
                                >
                                    <ListItem value="" disabled>
                                        <em>Recent Searches</em>
                                    </ListItem>
                                    {pastSearches.map((pastSearch) =>
                                        pastSearch ? (
                                            <MuiLink
                                                underline="none"
                                                component={Link}
                                                to={
                                                    pastSearch.searchName && pastSearch.filterName
                                                        ? `/search?query=${pastSearch.searchName}&filter=${pastSearch.filterName}`
                                                        : ''
                                                }
                                            >
                                                <ListItemButton dense onClick={handleListItemButtonClick}>
                                                    {pastSearch?.displayName}
                                                    &nbsp;
                                                    <ListItemText
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'flex-end',
                                                            ml: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">
                                                            {pastSearch?.filterName === 'ALL_VEHICLES'
                                                                ? 'INVENTORY'
                                                                : pastSearch?.filterName === 'VEHICLES_SOLD'
                                                                ? 'SOLD'
                                                                : pastSearch?.filterName === 'VEHICLES_IN_SALE'
                                                                ? 'IN SALE'
                                                                : pastSearch?.filterName === 'COMPANIES'
                                                                ? 'COMPANIES'
                                                                : pastSearch?.filterName === 'AGENTS'
                                                                ? 'AGENTS'
                                                                : undefined}
                                                        </Typography>
                                                    </ListItemText>
                                                </ListItemButton>
                                            </MuiLink>
                                        ) : null,
                                    )}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Box>
    )
}

export default withRouter(RecentSearch)
